import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export const LEGAL_UPDATED = "25 October 2026";
export const CONTACT = "pitchpaperresumes@gmail.com";

export const Section = ({ title, children, id, prefix }) => (
  <section className="mt-10" data-testid={`${prefix}-${id}`}>
    <h2 className="text-2xl text-ink">{title}</h2>
    <div className="mt-3 space-y-3 text-[15px] leading-relaxed text-ink-soft">{children}</div>
  </section>
);

export const ContactLink = ({ testId }) => (
  <a href={`mailto:${CONTACT}`} className="text-thread hover:underline" data-testid={testId}>{CONTACT}</a>
);

export const LegalPage = ({ title, testId, children }) => (
  <div className="min-h-screen bg-paper" data-testid={testId}>
    <header className="border-b border-paper-border">
      <div className="mx-auto flex h-16 max-w-3xl items-center px-4"><Logo size={28} /></div>
    </header>
    <main className="mx-auto max-w-3xl px-4 py-12 sm:py-16">
      <p className="eyebrow">Legal</p>
      <h1 className="mt-2 text-4xl text-ink sm:text-5xl">{title}</h1>
      <p className="mt-3 text-sm text-taupe">Last updated {LEGAL_UPDATED}</p>
      {children}
      <p className="mt-14 flex flex-wrap gap-4 border-t border-paper-border pt-6 font-mono text-xs text-taupe">
        <Link to="/" className="text-thread hover:underline" data-testid="legal-home-link">Back to Pitchpaper</Link>
        <Link to="/terms" className="hover:underline" data-testid="legal-terms-link">Terms</Link>
        <Link to="/privacy" className="hover:underline" data-testid="legal-privacy-link">Privacy</Link>
      </p>
    </main>
  </div>
);
